export default "__VITE_ASSET__AklZo0Lt__"